import { getHotkeyHandler } from './getHotkeyHandler.mjs';
import { toggleMark } from '../../../transforms/toggleMark.mjs';

/**
 * Factory to create a toggle mark handler for a given hotkey
 */

function getToggleMarkHotkey({
  type,
  hotkey
}) {
  return getHotkeyHandler(hotkey, editor => {
    toggleMark(editor, type);
  });
}

export { getToggleMarkHotkey };
